// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase, ref, push, set, onValue, off } from "firebase/database";
import { MessageProps } from "../types";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const firebaseDatabase = getDatabase();

/**
 * Send a message to a conversation in Firebase Realtime Database
 */
export async function sendMessage(
  conversationID: string,
  message: MessageProps
) {
  const messagesRef = ref(firebaseDatabase, `messages/${conversationID}`);
  const newMessageRef = push(messagesRef);
  await set(newMessageRef, message);
}

/**
 * Send a message to live chat in Firebase Realtime Database. Amen
 */
export async function sendLiveChatMessage(
  lessonID: string,
  message: MessageProps
) {
  const messagesRef = ref(firebaseDatabase, `messages/live-chats/${lessonID}`);
  const newMessageRef = push(messagesRef);
  await set(newMessageRef, message);
}

/**
 * Subscribe to messages in a conversation. Returns an unsubscribe function.
 */
export function subscribeToMessages(
  conversationID: string,
  callback: (messages: MessageProps[]) => void
) {
  const messagesRef = ref(firebaseDatabase, `messages/${conversationID}`);
  const listener = onValue(messagesRef, (snapshot) => {
    const data = snapshot.val();
    const messages: MessageProps[] = data ? Object.values(data) : [];
    callback(messages);
  });
  return () => off(messagesRef, "value", listener);
}

/**
 * Subscribe to live chat messages for a specific lesson. Returns an unsubscribe function.
 */
export function subscribeToLiveChatMessages(
  lessonID: string,
  callback: (messages: MessageProps[]) => void
) {
  const messagesRef = ref(firebaseDatabase, `messages/live-chats/${lessonID}`);
  const listener = onValue(messagesRef, (snapshot) => {
    const data = snapshot.val();
    const messages: MessageProps[] = data ? Object.values(data) : [];
    callback(messages);
  });
  return () => off(messagesRef, "value", listener);
}
